import axios from '@/lib/axios';
import { useMutation } from '@tanstack/react-query';

/**
 * 2230. MoneyForward連携設定削除
 * [DELETE] /workspaces/:identifier/money_forward_setting
 */
type Props = {
  identifier: string;
};

const destroyMoneyForwardSetting = (props: Props) => {
  return axios.delete(`/api/workspaces/${props.identifier}/money_forward_setting`);
};

export const useDestroyMoneyForwardSetting = () => {
  return useMutation({
    mutationFn: destroyMoneyForwardSetting,
  });
};
